import { useRouter } from "@/utils";
import { clsx } from "clsx";
import { FileNode } from "./FileNode";
import { useApiMutation } from "@/api/hooks/useApiMutation";
import { createDraft as createDraftMutation } from "@/entities/DataAssociation/DataAssociation.mutations";

export function CreateDraftItem({
    hasLabeledFiles,
    parentId,
}: {
    hasLabeledFiles: boolean;
    parentId: string;
}) {
    const router = useRouter();
    const companyId = router.params.companyId as string;

    const { mutate: createDraft, isPending } = useApiMutation(
        createDraftMutation,
        {
            onSuccess: (response) => {
                router.navigate(
                    `/beta/companies/${companyId}/labeling/files/${response.fileId}/drafts/${response.id}`,
                );
            },
        },
    );

    const lineElement = hasLabeledFiles ? (
        <div
            className={clsx(
                "absolute -bottom-8 left-[7px] top-0 w-px border-l-2 border-dashed border-slate-700",
                "mb-[14px] mt-6",
            )}
        />
    ) : null;

    return (
        <li className={clsx("relative flex flex-col gap-1")}>
            <FileNode
                icon={isPending ? "spinner" : "plus"}
                label={
                    isPending
                        ? "Creating a new draft..."
                        : "Create a new labeling draft"
                }
                onClick={() => createDraft({ fileId: parentId })}
                lineElement={lineElement}
                subdued
            />
        </li>
    );
}
